import * as Yup from 'yup';

export default Yup.object({
  name: Yup.string()
    .min(1, 'Must be 1 character or more')
    .max(255, 'Must be 255 characters or less')
    .required('Please enter a theme name'),
  logoUrl: Yup.string().required('Please upload a logo'),
  delayInSeconds: Yup.number()
    .min(1, 'The delay must be 1 second or greater')
    .required('Please specify a delay'),
  welcomePages: Yup.array().of(
    Yup.object().shape({
      text: Yup.string().required('Please enter welcome text'),
      textColor: Yup.string().required('Please select the text colour'),
      imageUrl: Yup.string().required('Please select an image'),
      opacityPercent: Yup.number()
        .min(0, 'Opacity must be between 0 and 100')
        .max(100, 'Opacity must be between 0 and 100')
        .required('Please supply an opacity value'),
    }),
  ),
});
